<template>
    <div class="cm-title">
        <span v-text="text" :style="{ fontSize: fontSize + 'px' }"></span>
    </div>
</template>

<script>
export default {
    name: 'CM_Title',
    props: {
        text: {
            type: String,
            required: true,
            default: '标题'
        },
        fontSize: {
            type: Number,
            default: 24
        }
    }
};
</script>

<style lang="less" scoped>
.cm-title span {
    position: relative;
    font-size: 20px;
    font-weight: bolder;
    color: #373c40;
    z-index: 1;

    &:after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 100%;
        height: 5px;
        background: #97ceff;
        z-index: -1;
    }
}
</style>
